import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { NavTabs } from '@/components/Elements'

const TABS_KEY = {
  GENERAL: 'general',
  SUBSCRIPTIONS: 'subscriptions',
}

const { GENERAL, SUBSCRIPTIONS } = TABS_KEY

export const Tabs = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()
  const location = useLocation()

  const basePath = `/billing`

  const TABS_CONFIG = {
    [GENERAL]: {
      label: t('general'),
      value: GENERAL,
      path: `${basePath}`,
    },
    [SUBSCRIPTIONS]: {
      label: t('subscription_plans'),
      value: SUBSCRIPTIONS,
      path: `${basePath}/subscriptions`,
    },
  }

  const tabsConfigValues = Object.values(TABS_CONFIG)

  const tabs = useMemo(() => {
    return tabsConfigValues.map(({ label, value }) => ({
      label,
      value,
    }))
  }, [])

  const onTabChange = (value: string) => {
    const tabConfig = TABS_CONFIG[value]

    navigate(`${tabConfig?.path}`)
  }

  const tabsValue = useMemo(() => {
    const pathName = location.pathname

    for (let i = 0; i < tabsConfigValues.length; i++) {
      const item = tabsConfigValues[i]

      if (pathName === item.path) {
        return item.value
      }
    }

    return ''
  }, [location])

  return (
    <>
      <NavTabs value={tabsValue} onChange={onTabChange} tabs={tabs} />
    </>
  )
}
